import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  Drawer,
  Autocomplete,
  useMediaQuery,
  TextField,
} from "@mui/material";

import commonStyles from "../../../Landing/addVariteyDrawerStyle";
import { useForm, Controller } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import {
  addFiles,
  openCountryDrawer,
  resetFiles,
  setCountryEdit,
  fetchVariety,
} from "../../../../../../slices/potatoProtectionSlice";
import Footer from "./Footer";
import FileUpload from "./FileUpload";
import DatePickerField from "../../../../../../utils/Fields/DatePickerField";
import Header from "./Header";
import TextInputField from "../../../../../../utils/Fields/TextInputField";
import DateFormat from "../../../../../../utils/DateFormat";
import axios from "../../../../../../API/API";
import { useParams } from "react-router-dom";
import { darkTheme, lightTheme } from "../../../../../../theme/Theme";
import { autoCompletStyles } from "../../../../../../utils/FieldStyles/FieldStyles";
import dayjs from "dayjs";
import { BASE_URL } from "../../../../../../constant/apiUrl";
import { postAPI } from "../../../../../../API/ApiService";
import { showErrorToast } from "../../../../../../utils/Toast/toast";
import { uploadFileAndGiveFileId } from "../../../../../../utils/function";
import Loading from "../../../../../../utils/Loader";
export default function EditCountryDrawer({ data, handleDeleteFile }) {
  const [loading, setLoading] = useState(false);
  const isDarkTheme = useSelector((state) => state.theme);
  const [select, setSelected] = useState("");
  const [editData, setEditData] = useState("");
  const { isCountryOpen, isCountryEdit, files } = useSelector(
    (store) => store.protectionPotato
  );

  const { countryFilter } = useSelector((store) => store.internalFilter);
  const token = localStorage.getItem("auth_token");
  const { register, handleSubmit, formState, reset, control } = useForm({
    defaultValues: {
      country: "",
      pbrRequestDate: null,
      pbrGrantDate: null,
      pbrNumber: "",
      registrationDate: null,
      registrationNumber: "",
      pvpRequestDate: null,
      pvpNumber: "",
      pvpGrantDate: null,
      patentFileDate: null,
      patentGrantDate: null,
      patentNumber: "",
    },
  });
  const { id } = useParams();
  useEffect(() => {
    dispatch(resetFiles());
  }, []);
  useEffect(() => {
    // Populate data based on the current selection.
    if (isCountryEdit) {
      const populateData = data?.filter((item) => item.country === select);

      // Even if the same country is selected, update editData with a deep comparison.
      if (
        populateData.length &&
        JSON.stringify(editData) !== JSON.stringify(populateData[0])
      ) {
        setEditData(populateData[0]);
      }
    }
  }, [select, data, editData, isCountryEdit]);

  useEffect(() => {
    if (isCountryOpen) {
      // Reset form and selection when the drawer opens.
      reset({
        country: "",
        pbrRequestDate: null,
        pbrGrantDate: null,
        pbrNumber: "",
        registrationDate: null,
        registrationNumber: "",
        pvpRequestDate: null,
        pvpNumber: "",
        pvpGrantDate: null,
        patentFileDate: null,
        patentGrantDate: null,
        patentNumber: "",
      });
      setEditData(null); // Clear previous data
      setSelected(""); // Clear selected country
    }
  }, [isCountryOpen, reset]);

  useEffect(() => {
    if (editData) {
      reset({
        country: editData.country || "",
        pbrRequestDate: editData.pbrRequestDate
          ? dayjs(editData.pbrRequestDate)
          : null,
        pbrGrantDate: editData.pbrGrantDate
          ? dayjs(editData.pbrGrantDate)
          : null,
        pbrNumber: editData.pbrNumber || null,
        registrationDate: editData.registrationDate
          ? dayjs(editData.registrationDate)
          : null,
        registrationNumber: editData.registrationNumber || null,
        pvpRequestDate: editData.pvpRequestDate
          ? dayjs(editData.pvpRequestDate)
          : null,
        pvpNumber: editData.pvpNumber || null,
        pvpGrantDate: editData.pvpGrantDate
          ? dayjs(editData.pvpGrantDate)
          : null,
        patentFileDate: editData.patentFileDate
          ? dayjs(editData.patentFileDate)
          : null,
        patentGrantDate: editData.patentGrantDate
          ? dayjs(editData.patentGrantDate)
          : null,
        patentNumber: editData.patentNumber || null,
      });
      dispatch(addFiles(editData?.newFiles));
    }
  }, [editData, reset]);
  // Use `JSON.stringify(variety)` to compare based on content

  const { errors } = formState;
  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    console.log(data, files, "--------");

    // Format all date fields
    const formattedDates = {
      pbrRequestDate: DateFormat(data.pbrRequestDate),
      registrationDate: DateFormat(data.registrationDate),
      pbrGrantDate: DateFormat(data.pbrGrantDate),
      pvpRequestDate: DateFormat(data.pvpRequestDate),
      patentFileDate: DateFormat(data.patentFileDate),
      patentGrantDate: DateFormat(data.patentGrantDate),
      pvpGrantDate: DateFormat(data.pvpGrantDate),
    };

    const newData = { ...data, ...formattedDates };

    // Create FormData and append files

    setLoading(true);
    if (isCountryEdit) {
      console.log(newData, files, "---------editDatatata-------");
      const fileToUpload = files.filter((item) => !item.id);
      const alreadyUploaded = files
        .filter((item) => item.id)
        .map((item) => item.id);
      try {
        const fileIds = await uploadFileAndGiveFileId(fileToUpload);
        const newFiles = [...alreadyUploaded, ...fileIds];
        const nuploadData = { ...newData, fileIds: newFiles };
        console.log(nuploadData, "----fileIDssss-----------");

        // Send the FormData payload
        const result = await axios.put(
          `${BASE_URL}/country-detail/variety/${id}/country/${editData?.id}`,
          nuploadData
        );
        if (result?.status === 200) {
          HandleClose();
          dispatch(fetchVariety(true));
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      } finally {
        setLoading(false);
      }
    } else {
      try {
        let fileIds = [];

        // Check if formData has files
        if (files.length > 0) {
          const fileId = await uploadFileAndGiveFileId(files);
          fileIds = [...fileId];
        }

        // Prepare data for the second API call
        const data1 = { ...newData, fileIds };

        const result = await postAPI(
          `${BASE_URL}/country-detail/variety/${id}`,
          data1,
          {
            headers: {
              Authorization: `Bearer ${token}`,

              "Content-Type": "application/json",
            },
          }
        );

        if (result?.status === 201) {
          HandleClose();
          dispatch(fetchVariety(true));
        }

        if (result?.status === 400) {
          showErrorToast("Country Name Cannot Be Repeated");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const onReset = () => {
    reset();
  };

  const HandleClose = () => {
    onReset();
    dispatch(openCountryDrawer(false));
    setEditData(" ");
    if (isCountryEdit === true) {
      dispatch(resetFiles());
      dispatch(setCountryEdit(false));
    }
  };

  const options = useMemo(() => {
    if (isCountryEdit) {
      return data?.map((item) => {
        return item?.country;
      });
    } else {
      const options = countryFilter.map((item) => item.name);
      return options;
    }
  }, [data, isCountryEdit, countryFilter]);

  const isMobile = useMediaQuery("(max-width: 600px)");

  return (
    <Drawer
      anchor={isMobile ? "bottom" : "right"}
      open={isCountryOpen}
      PaperProps={{
        sx: {
          height: isMobile ? "80%" : "100%",
          width: isMobile ? "100%" : 436,
          padding: isMobile ? "16px 16px" : "16px 24px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          background: isDarkTheme
            ? darkTheme.backgroundColorLayer3
            : lightTheme.backgroundColorLayer3,
        },
      }}
      ModalProps={{
        BackdropProps: {
          sx: {
            backgroundColor: isDarkTheme
              ? darkTheme.drawerOverlayColorLayer1
              : lightTheme.drawerOverlayColorLayer1,
          },
        },
      }}
    >
      {loading && <Loading />}
      <Header onClose={HandleClose} />

      <form
        className="w-full flex flex-col gap-3 h-full"
        onSubmit={handleSubmit(onSubmit)}
        data-testid="form"
      >
        <Box
          sx={{
            ...commonStyles.container,
            flex: 1,
            padding: "var(--Spacing-spacing-16, 16px)",
            backgroundColor: isDarkTheme
              ? darkTheme.backgroundColorLayer1
              : lightTheme.backgroundColorLayer1,
          }}
        >
          {/* Variety Input */}
          <Box sx={commonStyles.container}>
            <Typography
              sx={{
                ...commonStyles.typographyLabel,
                color: isDarkTheme && darkTheme.textColorLayer1,
              }}
            >
              Country name
            </Typography>
            <Controller
              name="country"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  {...field} // Spreads the field props
                  options={options}
                  getOptionLabel={(option) => option}
                  value={field.value || ""} // Value connected to the form's state
                  onChange={(e, newValue) => {
                    field.onChange(newValue); // Update form state
                    setSelected(newValue);
                  }}
                  sx={autoCompletStyles(isDarkTheme, isMobile, darkTheme)}
                  ListboxProps={{
                    sx: {
                      backgroundColor: isDarkTheme
                        ? darkTheme.backgroundColorLayer1
                        : "white",
                      "& .MuiAutocomplete-option": {
                        color: isDarkTheme ? "white" : "black",
                        "&:hover": {
                          backgroundColor: isDarkTheme ? "#333" : "#f0f0f0",
                        },
                      },
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select"
                      error={!!errors.country}
                      required
                      helperText={errors.country ? errors.country.message : ""}
                    />
                  )}
                />
              )}
            />
          </Box>
          <DatePickerField
            label="PBR request date"
            name="pbrRequestDate"
            control={control}
            errors={errors}
            isMobile={isMobile}
          />
          {/* Date Picker */}
          <DatePickerField
            label="PBR Grant date"
            name="pbrGrantDate"
            control={control}
            errors={errors}
            isMobile={isMobile}
          />

          <TextInputField
            label="PBR number"
            isMobile={isMobile}
            errors={errors}
            register={register}
            name="pbrNumber"
            datatestid="pbr-number"
          />
          {/* Country Autocomplete */}
          <DatePickerField
            label="Registration date"
            name="registrationDate"
            control={control}
            errors={errors}
            isMobile={isMobile}
          />
          <TextInputField
            label="Registration number"
            isMobile={isMobile}
            errors={errors}
            register={register}
            name="registrationNumber"
          />

          {/* Comments Text Area */}
          <DatePickerField
            label="PVP request date"
            name="pvpRequestDate"
            control={control}
            errors={errors}
            isMobile={isMobile}
          />
          <DatePickerField
            label="PVP grant date"
            name="pvpGrantDate"
            control={control}
            errors={errors}
          />

          <TextInputField
            label="PVP number"
            isMobile={isMobile}
            errors={errors}
            register={register}
            name="pvpNumber"
          />
          <DatePickerField
            label="Patent file date"
            name="patentFileDate"
            control={control}
            errors={errors}
            isMobile={isMobile}
          />
          <DatePickerField
            label=" Patent grant date"
            name="patentGrantDate"
            control={control}
            errors={errors}
            isMobile={isMobile}
          />
          <TextInputField
            label="Patent number"
            isMobile={isMobile}
            errors={errors}
            register={register}
            name="patentNumber"
          />
          <FileUpload data={data} handleDeleteFile={handleDeleteFile} />
        </Box>

        <Footer onClose={HandleClose} />
      </form>
    </Drawer>
  );
}
